const categories = [
  {
    id: 1,
    label: 'BREAKFAST',
    value: 'breakfast',
    subcategories: [
      { id: 101, label: 'momo', value: 'momo' },
      { id: 102, label: 'chowmein', value: 'chowmein' },
      { id: 103, label: 'roti', value: 'roti' },
      { id: 104, label: 'tass', value: 'tass' }
     
    ]
  },
  {
    id: 2,
    label: 'Launch',
    value: 'launch',
    subcategories: [
      { id: 201, label: "VEG-KHANA", value: 'veg_khana' },
      { id: 202, label: "MOTTON-KHANA", value: 'motton_khana' },
      { id: 203, label: 'CHICKEN-KHANA', value: 'chicken_khana' },
      { id: 204, label: 'KHANA+OMLET', value: 'khana_omlet' },
      { id: 205, label: 'RICE+ROTI', value: 'rice_roti' },
      { id: 206, label: 'KHANA+DALI', value: 'khana_dali' }
    ]
  },
  {
    id: 3,
    label: 'DRINKS',
    value: 'drinks',
    subcategories: [
      { id: 301, label: 'Juices', value: 'juices' },
      { id: 302, label: 'Sodas', value: 'sodas' },
      { id: 303, label: 'Water', value: 'water' },
      { id: 304, label: 'Coffee', value: 'coffee' },
      { id: 305, label: 'BLACK-TEA', value: 'black_tea' },
      { id: 306, label: 'MILK-TEA', value: 'milk_tea' }
    ]
  },
  {
    id: 4,
    label: 'HARD-DRINKS',
    value: 'hard_drinks',
    subcategories: [
      { id: 401, label: 'Whiskey', value: 'whiskey' },
      { id: 402, label: 'Vodka', value: 'vodka' },
      { id: 403, label: 'Rum', value: 'rum' },
      { id: 404, label: 'Tequila', value: 'tequila' },
      { id: 405, label: 'Gin', value: 'gin' },
      { id: 406, label: 'Brandy', value: 'brandy' }
    ]
  }
 
];

export default categories